import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {FeedbackCategory, feedbackDto} from './feedback-category.model';

export const loadFeedbackCategorys = createAction(
  '[FeedbackCategory/API] Load FeedbackCategorys',
  props<{ feedbackCategorys: FeedbackCategory[] }>()
);

export const addFeedbackCategory = createAction(
  '[FeedbackCategory/API] Add FeedbackCategory',
  props<{ feedbackCategory: FeedbackCategory }>()
);

export const upsertFeedbackCategory = createAction(
  '[FeedbackCategory/API] Upsert FeedbackCategory',
  props<{ feedbackCategory: FeedbackCategory }>()
);

export const addFeedbackCategorys = createAction(
  '[FeedbackCategory/API] Add FeedbackCategorys',
  props<{ feedbackCategorys: FeedbackCategory[] }>()
);

export const upsertFeedbackCategorys = createAction(
  '[FeedbackCategory/API] Upsert FeedbackCategorys',
  props<{ feedbackCategorys: FeedbackCategory[] }>()
);

export const updateFeedbackCategory = createAction(
  '[FeedbackCategory/API] Update FeedbackCategory',
  props<{ feedbackCategory: Update<FeedbackCategory> }>()
);

export const updateFeedbackCategorys = createAction(
  '[FeedbackCategory/API] Update FeedbackCategorys',
  props<{ feedbackCategorys: Update<FeedbackCategory>[] }>()
);

export const deleteFeedbackCategory = createAction(
  '[FeedbackCategory/API] Delete FeedbackCategory',
  props<{ id: string }>()
);

export const deleteFeedbackCategorys = createAction(
  '[FeedbackCategory/API] Delete FeedbackCategorys',
  props<{ ids: string[] }>()
);

export const clearFeedbackCategorys = createAction(
  '[FeedbackCategory/API] Clear FeedbackCategorys'
);

// Custom Actions
export const createFeedbackCategory = createAction(
  '[FeedbackCategory/API] Create FeedbackCategory',
  props<{ input: feedbackDto }>()
);

export const editFeedbackCategory = createAction(
  '[FeedbackCategory/API] Edit FeedbackCategory',
  props<{ input: feedbackDto }>()
);

export const removeFeedbackCategory = createAction(
  '[FeedbackCategory/API] Remove FeedbackCategory',
  props<{ categoryUniqueId: string, id: string }>()
);

export const getAllFeedbackCategories = createAction(
  '[FeedbackCategory/API] Get All FeedbackCategories'
);
